var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMavenlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.595 156.644L155.981 31.9955C155.503 30.3224 154.188 28.8883 152.276 28.1712C150.603 27.4542 147.974 27.6932 146.181 29.2468L95.8672 73.2264L45.673 29.3663C44.3584 28.1712 42.3268 27.3346 40.0561 27.9322C37.5464 28.6493 36.2318 30.5614 35.7537 32.3541L0.139778 156.644C-0.338261 158.317 -0.218751 160.827 1.45439 162.5C2.88851 163.934 4.80066 164.891 7.19086 164.412L95.9867 147.681L184.902 164.412C187.173 164.771 189.204 163.815 190.4 162.62C191.953 160.708 192.192 158.557 191.595 156.644ZM135.066 52.3122L115.945 90.7944L103.516 79.919L135.066 52.3122ZM88.2186 79.919L75.7895 90.7944L56.668 52.4317L88.2186 79.919ZM42.2073 45.9782L67.9019 97.726L13.8834 145.052L42.2073 45.9782ZM21.7711 151.386L72.5628 106.928L88.4576 138.837L21.7711 151.386ZM80.4504 100.116L95.8672 86.6115L111.284 100.116L95.8672 131.189L80.4504 100.116ZM103.277 138.837L119.172 106.928L170.083 151.386L103.277 138.837ZM123.833 97.6065L149.527 45.9782L177.731 144.693L123.833 97.6065Z",
    fill: "#00216E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMavenlink);
export default __webpack_public_path__ + "static/media/mavenlink.5e0c9fcc834addaf7a33a04b44ab4724.svg";
export { ForwardRef as ReactComponent };